/* esm.sh - @radix-ui/react-avatar@1.2.6 */
export * from "/*@radix-ui/react-avatar@1.2.6/esnext/react-avatar.mjs";
